<i18n src='../common_locales.yaml'></i18n>

<i18n>
en:
  ingredients: Ingredients
  add-ons: "Add-ons"
  special_instruction: "Special instruction"
  special_instruction_placeholder: "Add note (eg: extra sauce, no onions, etc)"
  add: Add
  to_cart: "to cart"
  allergies_information: "Allergies"
  bundled_item: "Bundled Items"
  item_included: "ITEMS INCLUDE"
  ingredient_are: "INGREDIENT"
  add_info: "Info"
  delivery_fee: "DELIVERY FEE"
  weight: "WEIGHT"
  price: "PRICE INCLUDING TAX"
  price_fee: "Price & Fee"
  expired_date: "EXPIRY DATE"
  how_to_keep: "HOW TO KEEP"
  how_to_cook: "HOW TO COOK"
  notes: "NOTES"
  no_info: "No information available"

ja:
  ingredients: "材料"
  add-ons: "アドオン"
  special_instruction: "特別指導"
  special_instruction_placeholder: "メモを追加する（例：余分なソース、玉ねぎなどなし)"
  add: "カートに"
  to_cart: "を加える"
  allergies_information: "アレルギー情報"
  bundled_item: "商品内容(入っているもの)"
  item_included: "アイテムに含まれるもの"
  ingredient_are: "原材料名"
  add_info: "情報"
  delivery_fee: "送料(税込)"
  weight: "内容量"
  price_fee: "価格と料金"
  price: "送料(税込)"
  expired_date: "賞味期限"
  how_to_keep: "保存方法"
  how_to_cook: "調理方法"
  notes: "使用上の注意"
  no_info: "利用可能な情報はありません"
</i18n>

<template lang="pug">
transition(name="modal")
  .modal-mask
    .modal-wrapper.modal(@click.self="$modal.close()")
      .modal-dialog(role="document")
        .modal-content
          .modal-header
            h3.modal-title {{locale_product_name}}
            button.close(type="button" @click="$modal.close()")
              span(aria-hidden="true") &times;
          .modal-body
            h3.text-center
              span.badge.badge-warning ¥ {{ product.price }}

            #carouselProductImages.carousel.slide(data-ride='carousel')
              ol.carousel-indicators
                li.active(v-for='(image, index) in selectedProduct.images' data-target='#carouselProductImages', :data-slide-to='index')
              .carousel-inner
                .carousel-item.text-center(v-for='(image, index) in selectedProduct.images' v-bind:class="{ active: index === 0 }")
                  img.img-fluid(:src='image.url')
              a.carousel-control-prev(v-if="showArrow" href='#carouselProductImages', role='button', data-slide='prev')
                span.carousel-control-prev-icon(aria-hidden='true')
                span.sr-only Previous
              a.carousel-control-next(v-if="showArrow" href='#carouselProductImages', role='button', data-slide='next')
                span.carousel-control-next-icon(aria-hidden='true')
                span.sr-only Next

            nav.mt-2
              #nav-tab.nav.nav-tabs(role='tablist')
                a#nav-bundleitem-tab.nav-item.nav-link.active(data-toggle='tab', href='#nav-bundleitem', role='tab', aria-controls='nav-bundleitem', aria-selected='true') {{$t('bundled_item')}}
                a#nav-ingredients-tab.nav-item.nav-link(data-toggle='tab', href='#nav-ingredients', role='tab', aria-controls='nav-ingredients', aria-selected='false') {{$t('ingredients')}}
                a#nav-price-tab.nav-item.nav-link(data-toggle='tab', href='#nav-price', role='tab', aria-controls='nav-price', aria-selected='false') {{$t('price_fee')}}
                a#nav-notes-tab.nav-item.nav-link(data-toggle='tab', href='#nav-notes', role='tab', aria-controls='nav-notes', aria-selected='false') {{$t('add_info')}}
              #nav-tabContent.tab-content.m-3
                #nav-bundleitem.tab-pane.fade.show.active(role='tabpanel', aria-labelledby='nav-bundleitem-tab')
                 p.my-2 {{$t('item_included')}}
                 p.my-2 {{locale_product_bundle_item}}
                #nav-ingredients.tab-pane.fade(role='tabpanel', aria-labelledby='nav-ingredients-tab')
                 p.my-2 {{$t('ingredient_are')}}
                 p.my-2 {{locale_product_ingredients}}
                #nav-price.tab-pane.fade(role='tabpanel', aria-labelledby='nav-price-tab')
                 p.my-2  {{$t('price')}} : ¥ {{product.price}}
                 p {{$t('delivery_fee')}} : {{locale_price_desc}}
                 p {{$t('weight')}} : {{locale_weight_description}}
                #nav-notes.tab-pane.fade(role='tabpanel', aria-labelledby='nav-notes-tab')
                 p.my-2 {{$t('expired_date')}} : {{locale_expired_date_desc}}
                 p {{$t('how_to_keep')}} : <span class="text-danger"> {{locale_how_to_keep}} </span>
                 p.mb-1 {{$t('how_to_cook')}}
                 p(v-if="locale_how_to_cook = ''") {{$t('no_info')}}
                 p(v-else) {{locale_how_to_cook}}
                 p.mb-1  {{$t('notes')}}
                 p {{locale_notes}}

            .row.mt-5
              .col-sm-4.mb-2
                ul.pagination.justify-content-center
                  li.page-item
                    a.page-link.minus(@click="pushMinus") -
                  li.page-item.disabled
                    a.page-link.text-quantity {{ quantity }}
                  li.page-item
                    a.page-link.plus(@click="pushPlus") +
              .col-sm-8.mb-2
                button.btn.btn-primary.btn-cart.btn-block(type="button" @click="pushAdd") {{$t('add')}} {{ cartItem.quantity }} {{$t('to_cart')}} <span class="text-price"> ¥{{ totalPrice }} </span>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import api from '../api'

export default {
  name: 'product-detail-view',
  props: ['restaurant', 'product'],
  computed: {
    selectedProduct () {
      return this.productData
    },
    ...mapState({
      deliveryType: state => state.cart.deliveryType
    }),
    ...mapGetters({
      cartRestaurant: 'getCartRestaurant',
      orderDeliveryType: 'getOrderDeliveryType',
      orderPostcode: 'getOrderPostcode',
      cartItems: 'getCartItems'
    }),
    cartItem () {
      const cartItem = {
        product: this.selectedProduct,
        quantity: this.quantity
      }
      return cartItem
    },
    totalPrice () {
      return this.quantity * this.selectedProduct.price
    },
    locale_product_name () {
      return this.selectedProduct['name_' + this.$i18n.locale]
    },
    locale_product_ingredients () {
      return this.selectedProduct['ingredients_' + this.$i18n.locale]
    },
    locale_product_bundle_item () {
      return this.selectedProduct['bundle_item_' + this.$i18n.locale]
    },
    locale_how_to_cook () {
      return this.selectedProduct['how_to_cook_' + this.$i18n.locale]
    },
    locale_expired_date_desc () {
      return this.selectedProduct['expired_date_desc_' + this.$i18n.locale]
    },
    locale_price_desc () {
      return this.selectedProduct['price_desc_' + this.$i18n.locale]
    },
    locale_weight_description () {
      return this.selectedProduct['weight_description_' + this.$i18n.locale]
    },
    locale_how_to_keep () {
      return this.selectedProduct['how_to_keep_' + this.$i18n.locale]
    },
    locale_notes () {
      return this.selectedProduct['notes_' + this.$i18n.locale]
    },
    showArrow () {
      if (this.selectedProduct.images) {
        return this.selectedProduct.images.length > 1
      }
      return false
    }
  },
  data () {
    return {
      productData: this.product,
      quantity: 1
    }
  },
  created () {
    this.fetchProductDetails()
  },
  mounted () {
    $('#productModal').on('hidden.bs.modal', () => {
      this.quantity = 1
      this.fetchProductDetails()
    })
  },
  methods: {
    ...mapActions([
      'setCartRestaurant',
      'setOrderDeliveryType',
      'setOrderPostcode',
      'addItemToCart',
      'clearCart'
    ]),
    fetchProductDetails () {
      api.get('/bentos/' + this.product.public_ident).then(response => {
        this.productData = response.data
      })
      .catch(e => {
        console.log(e)
      })
    },
    pushMinus () {
      if (this.cartItem.quantity > 1) {
        this.quantity--
      }
    },
    pushPlus () {
      this.quantity++
    },
    pushAdd () {
      if (this.cartRestaurant && this.cartRestaurant.public_ident !== this.restaurant.public_ident) {
        this.$toasted.info('Can\'t add bento from another store. Clear the cart first to proceed.',
          {
            duration: 5000,
            fitToScreen: true,
            action: [
              {
                text: 'Clear Cart',
                onClick: (e, toastObject) => {
                  this.clearCart()
                  this.$toasted.success('Cart cleared')
                  toastObject.goAway(0)
                }
              }
            ]
          }
        )
        return
      }

      if (this.orderDeliveryType && this.orderDeliveryType !== this.deliveryType) {
        this.$toasted.info('Can\'t mix different delivery type in single order. Clear the cart first to proceed.',
          {
            duration: 5000,
            fitToScreen: true,
            action: [
              {
                text: 'Clear Cart',
                onClick: (e, toastObject) => {
                  this.clearCart()
                  this.$toasted.success('Cart cleared')
                  toastObject.goAway(0)
                }
              }
            ]
          }
        )
        return
      }

      // If any bento exists in cart, make sure newly add bento is from the same restaurant
      if (this.cartRestaurant && this.cartRestaurant.public_ident !== this.restaurant.public_ident) {
        this.clearCart()
        this.setCartRestaurant(this.restaurant)
      }

      // Check delivery to saved postcode supported
      if (this.orderPostcode && this.orderPostcode.postcode) {
        api.get(`/postcodes/${this.orderPostcode.postcode}/?restaurant_public_id=${this.restaurant.public_ident}`)
        .then(response => {
          if (!response.data.hot_delivery_supported) {
            this.setOrderPostcode(null)
          }
        })
        .catch(e => {
          console.log(e)
          this.setOrderPostcode = null
        })
      }

      this.setCartRestaurant(this.restaurant)
      this.setOrderDeliveryType(this.deliveryType)

      const item = {...this.cartItem}
      this.addItemToCart(item)
      this.$modal.close()
      this.$modal.open('cart-dropdown', {attention: true})
    },
    addToppingPrice (price) {
    },
    locale_product_allergy (allergy) {
      return allergy['name_' + this.$i18n.locale]
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination {
  margin: 0 1rem;

  .text-quantity {
    padding-left: 1rem;
    padding-right: 1rem;
    font-weight: 500;
    color: #333;
  }

  .minus, .plus {
    font-weight: 500;
    color: #888;
  }
}
.btn-cart {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  font-weight: 500;
}
.text-price {
  font-size: 0.875rem;
  margin-left: 1rem;
  font-weight: 400;
}

</style>



// WEBPACK FOOTER //
// src/views/ProductDetailView.vue